import { render, staticRenderFns } from "./productParamGroup.vue?vue&type=template&id=6c762df0&scoped=true"
import script from "./productParamGroup.vue?vue&type=script&lang=js"
export * from "./productParamGroup.vue?vue&type=script&lang=js"
import style0 from "./productParamGroup.vue?vue&type=style&index=0&id=6c762df0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c762df0",
  null
  
)

export default component.exports